export const productsData = [
  {
    id: 1,
    category: 'Hardware Products',
    items: [
      {
        id: 'h1',
        name: 'Desktop Computers',
        description: 'High-performance desktop computers for business and personal use',
        features: ['Intel Core i5/i7/i9', '8GB-32GB RAM', 'SSD Storage', 'Windows 11 Pro'],
        image: 'https://images.unsplash.com/photo-1587831990711-23ca6441447b?w=400'
      },
      {
        id: 'h2',
        name: 'Workstations',
        description: 'Professional workstations for heavy computing tasks',
        features: ['Intel Xeon/AMD Threadripper', 'Up to 128GB RAM', 'Multiple GPU Support', 'ECC Memory'],
        image: 'https://images.unsplash.com/photo-1593640495253-23196b27a87f?w=400'
      },
      {
        id: 'h3',
        name: 'Business Laptops',
        description: 'Reliable laptops for business professionals',
        features: ['Dell, HP, Lenovo', '11th Gen Intel Core', 'FHD Display', 'Long Battery Life'],
        image: 'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=400'
      },
      {
        id: 'h4',
        name: 'Servers',
        description: 'Enterprise-grade rack and tower servers',
        features: ['Dell PowerEdge', 'HP ProLiant', 'Redundant PSU', 'Hot-Swap Drives'],
        image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=400'
      },
      {
        id: 'h5',
        name: 'Storage Solutions',
        description: 'Network-attached storage and SAN solutions',
        features: ['NAS & SAN', 'RAID Support', 'Scalable Storage', 'Data Protection'],
        image: 'https://images.unsplash.com/photo-1597852074816-d933c7d2b988?w=400'
      },
      {
        id: 'h6',
        name: 'Networking Devices',
        description: 'Switches, routers, and wireless access points',
        features: ['Cisco, Aruba, Ruckus', 'Managed Switches', 'Enterprise WiFi', 'VPN Routers'],
        image: 'https://images.unsplash.com/photo-1606904825846-647eb07f5be2?w=400'
      },
      {
        id: 'h7',
        name: 'Biometric Devices',
        description: 'Fingerprint and face recognition systems',
        features: ['Time Attendance', 'Access Control', 'Cloud Integration', 'Multi-device Support'],
        image: 'https://images.unsplash.com/photo-1633265486064-086b219458ec?w=400'
      },
      {
        id: 'h8',
        name: 'Printers',
        description: 'Laser and inkjet printers for office use',
        features: ['HP, Canon, Epson', 'Network Printing', 'Duplex Printing', 'High Capacity'],
        image: 'https://images.unsplash.com/photo-1612815154858-60aa4c59eaa6?w=400'
      }
    ]
  },
  {
    id: 2,
    category: 'Software & Cloud',
    items: [
      {
        id: 's1',
        name: 'Microsoft 365',
        description: 'Complete productivity suite for business',
        features: ['Office Apps', 'OneDrive Storage', 'Teams', 'Email & Calendar'],
        image: 'https://images.unsplash.com/photo-1633419461186-7d40a38105ec?w=400'
      },
      {
        id: 's2',
        name: 'Google Workspace',
        description: 'Cloud-based collaboration tools',
        features: ['Gmail', 'Drive Storage', 'Meet', 'Docs & Sheets'],
        image: 'https://images.unsplash.com/photo-1573804633927-bfcbcd909acd?w=400'
      },
      {
        id: 's3',
        name: 'Antivirus Solutions',
        description: 'Enterprise endpoint security',
        features: ['Kaspersky, ESET, McAfee', 'Real-time Protection', 'Centralized Management', 'Threat Detection'],
        image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=400'
      },
      {
        id: 's4',
        name: 'Backup Solutions',
        description: 'Automated backup and disaster recovery',
        features: ['Acronis, Veeam', 'Cloud Backup', 'Instant Recovery', 'Ransomware Protection'],
        image: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=400'
      },
      {
        id: 's5',
        name: 'SSL Certificates',
        description: 'Secure your websites with SSL/TLS',
        features: ['Domain Validation', 'Organization Validation', 'Wildcard SSL', '256-bit Encryption'],
        image: 'https://images.unsplash.com/photo-1614064641938-3bbee52942c7?w=400'
      },
      {
        id: 's6',
        name: 'Cloud Software',
        description: 'AWS, Azure, and Google Cloud services',
        features: ['IaaS & PaaS', 'Auto Scaling', 'Load Balancing', '99.9% Uptime'],
        image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=400'
      }
    ]
  },
  {
    id: 3,
    category: 'Security Solutions',
    items: [
      {
        id: 'sec1',
        name: 'Firewall Solutions',
        description: 'Next-generation firewall protection',
        features: ['Fortinet, Sophos, CheckPoint', 'Intrusion Prevention', 'VPN Support', 'Application Control'],
        image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=400'
      },
      {
        id: 'sec2',
        name: 'Endpoint Security',
        description: 'Advanced endpoint protection platform',
        features: ['EDR & EPP', 'Behavioral Analysis', 'Zero-day Protection', 'Automated Response'],
        image: 'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=400'
      },
      {
        id: 'sec3',
        name: 'Data Protection',
        description: 'Data loss prevention and encryption',
        features: ['DLP Solutions', 'Data Encryption', 'Access Control', 'Compliance Management'],
        image: 'https://images.unsplash.com/photo-1639322537228-f710d846310a?w=400'
      }
    ]
  }
];